import config from "../config/config";

export const BASE = "/api/";
export const BASE_ENDPOINT = config.API_BASE_URL;
export const API_ENDPOINT = BASE_ENDPOINT + BASE;

// Admin Public API
export const ADMIN_API_BASE_URL = config.ADMIN_API_BASE_URL;
export const ADMIN_PUBLIC_API_ENDPOINT = ADMIN_API_BASE_URL + BASE;
export const ADMIN_TOKEN_ENDPOINT = ADMIN_API_BASE_URL + "/token";

const BUSINESS_INFO = "BusinessInfo";
export const GET_BUSINESS_INFO_BY_COACH_ID =
  BUSINESS_INFO + "/GetBusinessInfoByCoachId/";
export const UPDATE_BUSINESS_INFO = BUSINESS_INFO + "/UpsertBusinessInfo";

export const MASTER = "Master";
export const GET_COUNTRY = MASTER + "/getCountry";
export const GET_STATE = MASTER + "/getState/";
export const GET_CURRENCY_DETAILS = MASTER + "/GetCurrencyDetails";
export const GET_MACRO_SPLIT_TEMPLATES = MASTER + "/GetMacroSplitTemplates";

const CONTENT_LIBRARY = "ContentLibrary/";
export const GET_CONTENT_LIBRARY = CONTENT_LIBRARY + "GetMediaFilesByCoachId";
export const POST_CONTENT_LIBRARY = CONTENT_LIBRARY + "UpsertMediaFile";
export const DELETE_CONTENT_LIBRARY =
  CONTENT_LIBRARY + "DeleteContentLibraryFiles";

const COACH_PROFILE = "CoachProfile/";
export const GET_COACH_PROFILE_BY_COACH_ID = COACH_PROFILE + "GetCoachById/";
export const GET_COACH_PROFILE_BY_EMAIL_ID =
  COACH_PROFILE + "GetCoachByEmailId/";
export const UPDATE_COACH_PROFILE = COACH_PROFILE + "UpsertCoach";

const LEAD = "Leads/";
export const GET_ALL_LEAD = LEAD + "getAllLeads";
export const FILTER_LEADS = LEAD + "filter";
export const POST_MULTIPLE_LEADS = LEAD + "PostMultipleLeads";
export const UPDATE_LEAD = LEAD + "UpdateLead";
export const ADD_OFFER = "offers";
export const DELETE_LEADS = LEAD + "DeleteLeads";
export const UPDATE_LEAD_STATUS = LEAD + "updateleadstatus";
export const SEND_OFFER = LEAD + "CreateLeadOfferDetails";
export const CREATE_FREE_CLIENT_OFFER = LEAD + "CreateLeadOfferFreeClientDetails";

const CLIENT_DASHBOARD = "/ClientDashboard";
export const GET_CLIENTS = "Client/GetClientsByCoachId";
export const GET_CLIENTS_LIST_FILTER_OPTIONS = "Client/GetFilterOptions";
export const GET_CLIENT_MEMBERSHIP_OVERVIEW =
  CLIENT_DASHBOARD + "/GetMembershipOverview";
export const UPDATE_CLIENT_WEIGHT_GOAL = CLIENT_DASHBOARD + "/UpdateWeightGoal";
export const GET_CLIENT_CHECK_IN_DETAILS =
  "ClientCheckIn/GetClientCheckInDetails";
export const GET_PROGRESS_OVERVIEW = CLIENT_DASHBOARD + "/GetProgressOverview";
export const GET_CLIENT_INFORMATION =
  CLIENT_DASHBOARD + "/getClientInformationByClientId";
export const POST_CLIENT_INFORMATION =
  CLIENT_DASHBOARD + "/updateClientInformation";

export const UPDATE_CHECKIN_READ_STATUS =
  "/ClientCheckIn/UpdateCheckInreadStatus";

export const TODO_TASK = "Dashboard";
export const GET_TODO_TASKS_FOR_COACH = TODO_TASK + "/GetTodoTasksForCoach";
export const CREATE_TODO_TASK = TODO_TASK + "/CreateTodoTask";
export const UPDATE_TODO_TASK_STATUS = TODO_TASK + "/UpdateTaskStatus";
export const GET_PIECHART_DATA = TODO_TASK + "/GetLeadsAcquisition";
export const GET_CLIENT_ANALYTICS = TODO_TASK + "/GetClientAnalytics";
export const DELETE_TODO_TASK = TODO_TASK + "/DeleteToDoTask";
export const UPDATE_TODO_TASK = TODO_TASK + "/UpdateTodoTask";

const EXERCISE = "Exercise/";
export const GET_ALL_EXERCISES = EXERCISE + "GetAllExercises";
export const FILTER_EXERCISES = EXERCISE + "filter";
export const UPSERT_EXERCISE = EXERCISE + "UpsertExercise";
export const UPDATE_EXERCISE_STATUS = EXERCISE + "UpdateExercisestatus";
export const EXERCISE_GET_SASS_TOKEN = EXERCISE + "GetSasToken";

const WORKOUT = "Workout/";
export const Get_Workout_Preference = WORKOUT + "GetWorkoutPreference";
export const UPDATE_WORKOUT_PREFERENCE = WORKOUT + "UpdateWorkoutPreference";

const WORKOUT_TEMPLATE = "WorkoutTemplate/";
export const GET_WORKOUT_TEMPLATE =
  WORKOUT_TEMPLATE + "GetWorkoutTemplateByCoachId";
export const DELETE_WORKOUT_TEMPLATE =
  WORKOUT_TEMPLATE + "DeleteWorkoutTemplate";
export const CREATE_WORKOUT_TEMPLATE =
  WORKOUT_TEMPLATE + "CreateWorkoutTemplate";
export const GET_WORKOUT_TEMPLATE_DETAILS_BY_ID =
  WORKOUT_TEMPLATE + "GetWorkoutTemplateDetailsById";
export const FILTER_WORKOUT_TEMPLATE =
  WORKOUT_TEMPLATE + "FilterWorkoutTemplate";
export const UPDATE_WORKOUT_TEMPLATE =
  WORKOUT_TEMPLATE + "UpdateWorkoutTemplate";

// Payment
export const GET_LEAD_OFFER_DETAILS = "/LeadOffer/GetLeadOfferDetails";
export const GET_LEAD_OFFER_DETAILS_BY_ID =
  "/LeadOffer/GetLeadOfferDetailsById";
export const SEND_EMAIL = "/Email/SendLeadOfferDetailsEmail";

// Stripe
export const CREATE_CHECKOUT_SESSION = "/Payment/CreateCheckoutSession";
export const ADD_CUSTOMER_PAYMENT_METHOD = "/Payment/AddCustomerPaymentMethod";
export const SET_UP_STRIPE_FOR_COACH = "/Stripe/SetupStripeForCoach";
export const ADD_CUSTOMER_PAYMENT_METHOD_STRIPE_FOR_COACH =
  "/Stripe/AddCustomerPaymentMethod";
// Admin Stripe
export const GET_CLIENT_CHECKOUT_SESSION = "createcustomer";
export const ADD_CUSTOMER_PAYMENT_METHOD_STRIPE_FOR_CLIENT = "/success";

// coach offer
export const GET_COACH_CHECKOUT_SESSION = "createcoachcustomer";
export const GET_LEAD_OFFER_COACH = "getleadoffercoach";
export const POST_PAYMENT_METHOD_STRIPE_FOR_LEAD_SUCCESS_COACH = "leadsuccess";

// Payment Tab
export const GET_PAYMENT_HISTORY = "/Payment/GetPaymentHisotry";
export const UPDATE_PAYMENT_DETAILS = "/Payment/UpdatePaymentDetails";
export const UPDATE_PAYMENT_DETAILS_RETRY = "/Payment/UpdatePaymentDetailsRetry";
export const RETRY_PAYMENT = "retrypayment";

export const PAUSE_CLIENT_SUBSCRIPTION =
  "/Subscription//PauseClientSubscription";
export const END_CLIENT_SUBSCRIPTION = "/Subscription/EndClientSubscription";

export const POST_WORKOUT_PLAN = WORKOUT + "UpsertClientWorkoutPlan";
export const GET_WORKOUT_PLAN = WORKOUT + "GetClientWorkoutPlan";
export const DELETE_WORKOUT_PLAN = WORKOUT + "deleteClientWorkoutPlan";
export const GET_WORKOUT_LIST = "ClientActivity";

export const GET_WORKOUT_HISTORY = WORKOUT + "GetWorkoutHistory";
export const GET_WORKOUT_TEMPLATE_LIST =
  WORKOUT_TEMPLATE + "GetWorkoutTemplateByCoachId";
export const GET_WORKOUT_TEMPLATE_BY_ID =
  WORKOUT_TEMPLATE + "GetWorkoutTemplateDetailsById";

export const GET_CLIENT_REMINDER = "Client/GetClientReminder";
export const POST_CLIENT_REMINDER = "Client/UpsertClientReminder";

export const GET_BODY_PARTS = EXERCISE + "GetBodyParts";
export const GET_EQUIPMENT = EXERCISE + "GetEquipments";
export const GET_MUSCLE_GROUPS = EXERCISE + "GetMuscles";

// notifications
export const GET_NOTIFICATION_DETAILS = "Notification/GetNotificationDetails";
export const GET_ANNOUNCEMENT_LIST = "Announcement/GetAnnouncementDetails";
export const UPDATE_NOTIFICATION_COUNT =
  "Notification/UpdateNotificationDetails";

//Recipes
const RECIPE = "Recipe/";
export const GET_RECIPES_LIST = RECIPE + "GetPopularRecipes";
export const GET_FILTERED_RECIPE_WITH_MEAL_TIME =
  "/" + RECIPE + "getFilteredRecipeWithMealTime";
export const UPDATE_STANDARD_RECIPES = RECIPE + "UpdateStandardRecipe";
export const DELETE_STANDARD_RECIPE_BY_ID = RECIPE + "DeleteStandardRecipe?recipeId=";

// export const GET_RECIPES_FILTER = RECIPE + "FilterRecipe";
export const GET_RECIPES_FILTER = RECIPE + "FilterRecipeNew";
export const GET_RECIPE_BY_ID = RECIPE + "GetRecipeById";
export const GET_CUISINES = RECIPE + "GetCuisinesList";
export const GET_TAGS = RECIPE + "GetTagsList";
export const POST_MARK_AS_COMPLETE = RECIPE + "SaveUserFavouriteRecipe";
export const FETCH_FAVORITE_RECIPE = RECIPE + "GetUserFavoriteRecipes";
export const FETCH_AUTO_COMPLETE = RECIPE + "AutocompleteRecipe";
export const ADD_MEALPLAN_RECEIPE = RECIPE + "AddRecipe";

// Filter recipes
export const GET_STANDARD_RECIPES = RECIPE + "GetStandardReceipe";
export const GET_CUSTOMIZED_RECIPES = RECIPE + "GetResizeRequest";

// meal plan summary
const MEAL_PLAN = "MealPlan";
export const FETCH_MEAL_PLAN_SUMMARY = `${MEAL_PLAN}/GetMealPlanSummaryByRecipeId`;
export const GET_MEAL_RESTRICTIONS = `/${MEAL_PLAN}/GetMealRestrictionsList`;
export const CREATE_MEAL_PLAN = `/${MEAL_PLAN}/CreateMealPlan`;
export const UPSERT_MEAL_PLAN = `/${MEAL_PLAN}/UpsertMealPlan`;
export const GET_MEAL_PLAN_DETAILS = `/${MEAL_PLAN}/GetMealPlanDetails`;
export const GET_ALL_PREFERENCES_ALLERGIES = `/${MEAL_PLAN}/GetAllPreferencesAndAllergies`;
export const FETCH_MEALPLAN_RECIPES = `${MEAL_PLAN}/GetReceipes`;
export const GET_RECEIPE_IMAGE = `${MEAL_PLAN}/GetReceipeImage`;

// chat endpoint
export const CHATHUB = "/chathub";
export const GET_CHAT_BOT_DETAILS = "/ChatBot/GetChatDetails";
export const UPDATE_EXERCISE_DETAILS_ON_SESSION_ID = "/ChatBot/UpdateExerciseDetailsOnSessionId";

// Messenger
const messenger = "/Messenger";
export const ADD_MESSENGER_CONVERSION_DETAILS =
  messenger + "/addMessengerConversationDetails";
export const GET_MESSENGER_CONVERSION_DETAILS =
  messenger + "/GetMessengerConversationDetails";
export const GET_CONVERSION_DETAILS = messenger + "/GetConversationDetails";
export const GET_MESSENGER_CHECKIN_CLIENTS_LIST =
  messenger + "/GetMessengerCheckInClientsList";
export const CREATE_TOKEN = messenger + "/createToken";
export const GET_MESSENGER_CLIENTS_LIST_BY_FILTER =
  messenger + "/GetMessengerClientsListByFilter";
export const RESET_UNREAD_COUNT = messenger + "/ResetUnreadCount";

// Concerns
export const FETCH_CONCERNS_LIST = "SupportTicket/GetSupportIssueList";
export const FETCH_CONCERNS_CONVERSATION_LIST =
  "SupportTicket/GetSupportIssueconversation";
export const POST_CONCERNS_CONVERSATION = "SupportTicket/SendIssueMessage";
export const CREATE_SUPPORT_TICKET = "SupportTicket/CreateSupportIssue";

export const GET_MOBILE_APP_DETAILS = "/GetMobileAppDetails";
export const GET_COACH_ONBOARDING_PROCESS = "/coachonboardingprocess";

export const COACH_CARD_UPDATE_SUCCESS = "/coachupdatecardsuccess";
export const COACH_ONBOARD_SUCCESS = "/coachonboardsuccess";
